// Shared upload MIME rules

export const SUPPORTED_FILE_TYPES =
  /^image\/(jpeg|jpg|png|webp)$|^application\/pdf$/i;
export const SUPPORTED_FILE_EXTENSIONS = /\.(jpe?g|png|webp|pdf)$/i;

export const isSupportedUploadFile = (file) => {
  if (!file) return false;
  if (SUPPORTED_FILE_TYPES.test(file.type || "")) return true;
  return SUPPORTED_FILE_EXTENSIONS.test((file.name || "").toLowerCase());
};
